import * as React from "react";
import { META_DEFAULTS } from "../../core/config";

var _React$createContext = React.createContext(META_DEFAULTS),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

export { Provider, Consumer };